import { YodaFieldValue } from 'services/yodaForm/yodaForm.types';

export const transformProgram = (data: YodaFieldValue) => {
  const programLogoIdToDB = data.programLogo?.map((item: { id: string }) => item.id)[0];
  const programLogoUrlToDB = data.programLogo?.map((item: { url: string }) => item.url)[0];
  return data.programLogo ? { ...data, programLogo: programLogoIdToDB, programLogoUrl: programLogoUrlToDB } : data;
};
